module.exports = "<manageProfile></manageProfile>"